import { ChangeDetectionStrategy, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '@app/services/login/login.service';
import { UtilidadesService } from '@app/services/utilidades.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'sb-forgot-password',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './forgot-password.component.html',
    styleUrls: ['forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
    @ViewChild('confirmationModal') confirmationModal!: TemplateRef<unknown>;
    @ViewChild('toastHeader') toastHeader!: TemplateRef<unknown>;

    forgotPasswordForm = this.fb.group({
        email: ['', [Validators.required, Validators.email]],
    });

    constructor(
        private fb: FormBuilder, 
        private modalService: NgbModal, 
        private router: Router,
        private loginService: LoginService,
        private utilidadesService: UtilidadesService
        ) {}
    ngOnInit() {}

    async onSubmit() {
        if (this.forgotPasswordForm.status === 'VALID') {
            let email = this.forgotPasswordForm.get('email')?.value;
            this.utilidadesService.setLoading('reestablecer',true);
            let rpta:any = await this.loginService.setOlvideClave(email);
            this.utilidadesService.setLoading('reestablecer',false);
            if (rpta.status == 'success'){
                this.forgotPasswordForm.controls['email'].setValue('');
                this.utilidadesService.showToastSinDelay(this.toastHeader,rpta.msj,{headerClasses:'text-success'});
            }else{
                this.utilidadesService.showToastSinDelay(this.toastHeader,rpta.msj,{headerClasses:'text-danger'});
            }
        }

        for (const key in this.forgotPasswordForm.controls) {
            const control = this.forgotPasswordForm.controls[key];
            control.markAllAsTouched();
        }
    }

    /* Accessor Methods */

    get emailControl() {
        return this.forgotPasswordForm.get('email') as FormControl;
    }

    get emailControlValid() {
        return this.emailControl.touched && !this.emailControlInvalid;
    }

    get emailControlInvalid() {
        return (
            this.emailControl.touched &&
            (this.emailControl.hasError('required') || this.emailControl.hasError('email'))
        );
    }
}
